import { render, staticRenderFns } from "./ReviewResult.vue?vue&type=template&id=2a89cd2e&scoped=true&"
import script from "./ReviewResult.vue?vue&type=script&lang=js&"
export * from "./ReviewResult.vue?vue&type=script&lang=js&"
import style0 from "./ReviewResult.vue?vue&type=style&index=0&id=2a89cd2e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a89cd2e",
  null
  
)

export default component.exports